export const HIGHLIGHT_GEOJSON_COUNTRY_LAYER = 'HIGHLIGHT_GEOJSON_COUNTRY_LAYER';
export const SHOW_COUNTRY_NAME_TOOLTIP = 'SHOW_COUNTRY_NAME_TOOLTIP';
